import { Card, Col, Form, Input, Modal, Row } from "antd"
import { CustomBtn } from "../../../../components/commonComponents"
import { PlusOutlined } from "@ant-design/icons"
import { addDepartment, updateDepartment } from "../actions";
import { useEffect } from "react";

export const DepartmentModal = ({ open, close, reload, data }) => {
    const [form] = Form.useForm();
    const onFinish = (values) => {
        if (data) {
            updateDepartment(values, data.id).then(res => {
                reload()
                console.log(res)
                close(false)
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                reload()
            })
        } else {
            addDepartment(values).then(res => {
                reload()
                console.log(res)
                close(false)
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                reload()
            })
        }
    }
    useEffect(() => {
        if (data) {
            form.setFieldsValue(data)
        }
    }, [data])
    return (
        <Modal
            title={data ? "დეპარტამენტის რედაქტირება" : "დეპარტამენტის დამატება"}
            open={open}
            onCancel={close}
            footer={[
                <CustomBtn key="submit" label="დამატება" onClick={form.submit} color="green" icon={<i className="fa-solid fa-circle-plus"></i>} colorHover={'#135200'} htmlType="submit" />,
                <CustomBtn key="cancel" label="დახურვა" onClick={() => { close(false) }} color="gray" icon={<i className="fa-solid fa-circle-xmark"></i>} colorHover={'#000'} />
            ]}
        >
            <Form
                size="small"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={onFinish}
                form={form}
            >
                <Card
                    style={{ boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)' }}
                >
                    <Row gutter={[16, 16]} >
                        <Col span={12}>
                            <Form.Item label="დასახელება" name="name"
                                rules={[
                                    { required: true, message: 'დასახელება სავალდებულოა' }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Code" name="code"
                                rules={[
                                    { required: true, message: 'Code სავალდებულოა' }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="კომენტარი" name="description">
                                <Input.TextArea />
                            </Form.Item>
                        </Col>
                    </Row>
                </Card>
            </Form>
        </Modal>
    )
}